import { ThemeService } from '@shared/services/theme.service';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  private _themeService = inject(ThemeService);

  ngOnInit(): void {
    this._themeService.isHml() ?? this._themeService.toggleHmlTheme();
  }
}
